/* <compare-slider> — loaded by sections/before-after.liquid.
   Runs after theme.js (defer order); shared helpers come from window.themeFocus. Guarded against double inclusion. */
(() => {
  'use strict';
  if (window.__bpModules && window.__bpModules['compare-slider']) return;
  (window.__bpModules = window.__bpModules || {})['compare-slider'] = true;

/* -----------------------------------------------------------------------------
   <compare-slider> — before/after image comparison
   --------------------------------------------------------------------------- */
class CompareSlider extends HTMLElement {
  connectedCallback() {
    const range = this.querySelector('[data-range]');
    if (!range) return;
    const update = () => this.style.setProperty('--pos', range.value + '%');
    range.addEventListener('input', update);
    update();
    /* Theme editor: selecting the Before/After block reveals that image fully */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        range.value = e.target.classList.contains('ba__layer--top') ? '100' : '0';
        update();
      });
    }

    /* Hint: when the section enters the viewport the handle nudges left-right once (0.7s, cart curve).
       Not if the user has touched it or prefers reduced motion. */
    if (!this.hasAttribute('data-hint') || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let touched = false;
    range.addEventListener('pointerdown', () => { touched = true; }, { once: true });
    const io = new IntersectionObserver((es) => {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      if (touched) return;
      const start = parseFloat(range.value);
      const t0 = performance.now(), dur = 700;
      const ease = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; /* ease-in-out */
      const step = (now) => {
        if (touched) return;
        const p = Math.min(1, (now - t0) / dur);
        /* 0 → -4 → 0 (%): half sine */
        range.value = String(start - 4 * Math.sin(ease(p) * Math.PI));
        update();
        if (p < 1) requestAnimationFrame(step); else { range.value = String(start); update(); }
      };
      requestAnimationFrame(step);
    }, { threshold: 0.6 });
    io.observe(this);
  }
}
if (!customElements.get('compare-slider')) {
  customElements.define('compare-slider', CompareSlider);
}
})();
